module.exports = __webpack_public_path__ + "static/media/bio_sm.56eb199f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bio_sm.jpg
// module id = 5959
// module chunks = 0